import Observer from "./Observer";

var moment = require('moment');
moment().format();

class CustomerModel extends Observer
{
    /**
     * GUID generated by api
     * @type {string}
     */
    Id = "";
    
    ClientId = "";
    /***
     * salutation of customer
     * @type {string}
     */
    Salutation = "";
    /**
     * name of customer
     * @type {string}
     */
    Name1 = "";
    /**
     * firstname of customer
     * @type {string}
     */
    Name2 = "";
    /**
     * oAddressAddition
     * @type {string}
     */
    Name3 = "";

    /**
     * customer date of birth
     * @type {Date}
     */
    DateOfBirth = moment();
    /**
     * name of street
     * @type {string}
     */
    Street = "";
    /**
     * house number of customer address
     * @type {string}
     */
    HouseNumber = "";
    /**
     * house number addition of customer address
     * @type {string}
     */
    HouseNumberAddition = "";

    /**
     * zip of customer
     * @type {string}
     */
    PostCode = "";
    City = "";
    /**
     * customer number
     * @type {string}
     */
    CustomerNumber = "";

    /**
     * email address of customer
     * @type {string}
     */
    Email = "";
    /**
     * phone number of customer
     * @type {string}
     */
    Phone = "";
    /**
     * working phone number of customer
     * @type {string}
     */
    Phone2 = "";

    Fax = "";

    Gender = "";

    Class = "";
    GradeLevel = "";
    Country = "";
    Title = "";
    /**
     bool
     **/
    MarketingPost = false;
    /**
     bool
     **/
    MarketingEmail = false;
    /**
     bool
     **/
    MarketingPhone = false;
    /**
     bool
     **/
    FlagMarketing = false;
    CustomerCategory = [];

    /**
     * all onntracts of customer
     * @type {Array}
     */
    Contracts = [];
    
    SelectedContract = null;
    /**
     *
     * @param customerNumber
     * @param client
     * @param vu
     * @constructor
     */
    GetCustomer(id)
    {
       
        
    }
    /**
     *
     * @constructor
     */
    GetContracts(id)
    {
        /*let me = this;
        RequestHelper.SendAuthorised(Vas.ApiUrl+"/contract/",false,"GET",{ id: id, value: "BbCu" },false).then(function(data)
        {
            if(data.Data && data.Data.length > 0)
            {
                data.Data.map(p => {
                    let contract = new Contract();
                    contract.Id       = p.Id;
                    contract.DateFrom =  p.DateFrom;
                    contract.DateTo =  p.DateTo;
                    contract.Status = p.Status;
                    contract.ContractNumber = p.ContractNumber;
                    contract.TicketName = p.TicketName;
                    me.Contracts.push(contract)
                    return me
                });
            }
            me.Notify();
        });*/
    }
}
export default CustomerModel;